import { render, staticRenderFns } from "./batch-set-pit.vue?vue&type=template&id=70b9ccab&scoped=true&"
import script from "./batch-set-pit.vue?vue&type=script&lang=js&"
export * from "./batch-set-pit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b9ccab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b9ccab')) {
      api.createRecord('70b9ccab', component.options)
    } else {
      api.reload('70b9ccab', component.options)
    }
    module.hot.accept("./batch-set-pit.vue?vue&type=template&id=70b9ccab&scoped=true&", function () {
      api.rerender('70b9ccab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Selected-products/modules/batch-set-pit.vue"
export default component.exports